import React, { useState, useEffect } from "react";

function Inventory() {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [makingType, setMakingType] = useState("fixed");
  const [scanInput, setScanInput] = useState("");
  const [showHikeModal, setShowHikeModal] = useState(false);
  const [hikeForm, setHikeForm] = useState({
    hikeType: "percent",
    hikeValue: "",
    effectiveDate: new Date().toISOString().split("T")[0],
  });
  const [hikeLoading, setHikeLoading] = useState(false);
  const [scanResult, setScanResult] = useState(null);
  const [form, setForm] = useState({
    name: "",
    category: "",
    purity: "",
    weightGrams: "",
    makingCharge: "",
    quantity: "",
    huid: "",
    karigar: "",
  });

  const printBarcode = (barcode, name) => {
    const win = window.open("", "_blank");
    win.document.write(`
      <html>
        <body style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;margin:0;background:white;">
          <svg id="barcode"></svg>
          <p style="font-family:Arial;font-size:12px;margin-top:8px;color:#333">${name}</p>
          <p style="font-family:monospace;font-size:10px;color:#888">${barcode}</p>
          <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.12.3/dist/JsBarcode.all.min.js"></script>
          <script>
            JsBarcode("#barcode", "${barcode}", {
              format: "CODE128", width: 2, height: 80, displayValue: true
            });
            window.print();
          </script>
        </body>
      </html>
    `);
    win.document.close();
  };

  useEffect(() => {
    fetch(`/api/inventory?userId=${parseInt(localStorage.getItem("userId"))}`)
      .then((r) => r.json())
      .then((data) => setItems(data));
  }, []);
  const handleScan = (e) => {
    if (e.key === "Enter" && scanInput.trim() !== "") {
      const found = items.find((item) => item.barcode === scanInput.trim());
      if (found) {
        setScanResult(found);
      } else {
        setScanResult({ notFound: true, barcode: scanInput });
      }
      setScanInput("");
    }
  };

  const applyPriceHike = () => {
    if (!hikeForm.hikeValue || parseFloat(hikeForm.hikeValue) <= 0) {
      alert("Please enter a valid hike value");
      return;
    }
    setHikeLoading(true);
    fetch(
      `/api/inventory/hike?userId=${parseInt(localStorage.getItem("userId"))}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          hikeType: hikeForm.hikeType,
          hikeValue: parseFloat(hikeForm.hikeValue),
          effectiveDate: new Date(hikeForm.effectiveDate).toISOString(),
        }),
      },
    )
      .then((r) => r.json())
      .then((d) => {
        alert(`✅ ${d.message}`);
        setShowHikeModal(false);
        setHikeLoading(false);
        // Refresh inventory
        fetch(
          `/api/inventory?userId=${parseInt(localStorage.getItem("userId"))}`,
        )
          .then((r) => r.json())
          .then((data) => setItems(data));
      })
      .catch(() => {
        alert("Error applying price hike");
        setHikeLoading(false);
      });
  };
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const making =
      makingType === "percent"
        ? parseFloat(form.weightGrams) *
          (parseFloat(form.makingCharge) / 100) *
          1000
        : parseFloat(form.makingCharge);

    fetch(`/api/inventory?userId=${parseInt(localStorage.getItem("userId"))}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...form,
        weightGrams: parseFloat(form.weightGrams),
        makingCharge: making,
        quantity: parseInt(form.quantity),
        status: "In Stock",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setItems([...items, data]);
        setShowForm(false);
        setMakingType("fixed");
        setForm({
          name: "",
          category: "",
          purity: "",
          weightGrams: "",
          makingCharge: "",
          quantity: "",
          huid: "",
          karigar: "",
        });
      });
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    background: "#C2B067",
    border: "1px solid #856A00",
    borderRadius: "6px",
    color: "#403301",
    fontSize: "13px",
  };
  const labelStyle = {
    fontSize: "12px",
    color: "#403301",
    display: "block",
    marginBottom: "4px",
  };

  const getPurityLabel = () =>
    form.category === "Diamond" ? "Carat" : "Purity";
  const getPurityPlaceholder = () => {
    if (form.category === "Gold") return "e.g. 22K, 24K, 18K";
    if (form.category === "Silver") return "e.g. 925, 999, 800";
    if (form.category === "Diamond") return "e.g. 0.5, 1.0, 2.5";
    return "e.g. 22K";
  };

  return (
    <div
      style={{
        flex: 1,
        padding: "30px",
        background: "#f8f9fa",
        color: "#403301",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>Inventory</h2>
          <p style={{ margin: 0, color: "#856A00", fontSize: "12px" }}>
            {items.length} items
          </p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            background: "#856A00",
            color: "gold",
            border: "none",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          + Add Item
        </button>
      </div>
      <div style={{ display: "flex", gap: "8px" }}>
        <button
          onClick={() => setShowHikeModal(true)}
          style={{
            background: "#403301",
            color: "#efbf04",
            border: "1px solid #856A00",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          Price Hike
        </button>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            background: "#856A00",
            color: "gold",
            border: "none",
            padding: "8px 16px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          + Add Item
        </button>
      </div>
      {/* Price Hike Modal */}
      {showHikeModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "24px",
              width: "400px",
            }}
          >
            <h3 style={{ marginTop: 0, color: "#403301" }}>Apply Price Hike</h3>
            <p style={{ fontSize: "12px", color: "#403301", marginTop: 0 }}>
              This will update Making Charge for all inventory items
            </p>

            <div style={{ marginBottom: "12px" }}>
              <label
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  display: "block",
                  marginBottom: "4px",
                }}
              >
                Effective Date
              </label>
              <input
                type="date"
                value={hikeForm.effectiveDate}
                onChange={(e) =>
                  setHikeForm({ ...hikeForm, effectiveDate: e.target.value })
                }
                style={{
                  width: "100%",
                  padding: "8px",
                  background: "#C2B067",
                  border: "1px solid #856A00",
                  borderRadius: "6px",
                  color: "#403301",
                  fontSize: "13px",
                }}
              />
            </div>

            <div style={{ marginBottom: "12px" }}>
              <label
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  display: "block",
                  marginBottom: "4px",
                }}
              >
                Hike Type
              </label>
              <select
                value={hikeForm.hikeType}
                onChange={(e) =>
                  setHikeForm({ ...hikeForm, hikeType: e.target.value })
                }
                style={{
                  width: "100%",
                  padding: "8px",
                  background: "#C2B067",
                  border: "1px solid #856A00",
                  borderRadius: "6px",
                  color: "#403301",
                  fontSize: "13px",
                }}
              >
                <option value="percent">% Percentage</option>
                <option value="fixed">₹ Fixed Amount</option>
              </select>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  display: "block",
                  marginBottom: "4px",
                }}
              >
                {hikeForm.hikeType === "percent" ? "Hike %" : "Hike Amount (₹)"}
              </label>
              <input
                type="number"
                min="0"
                placeholder={
                  hikeForm.hikeType === "percent" ? "e.g. 5" : "e.g. 500"
                }
                value={hikeForm.hikeValue}
                onChange={(e) =>
                  setHikeForm({ ...hikeForm, hikeValue: e.target.value })
                }
                style={{
                  width: "100%",
                  padding: "8px",
                  background: "#C2B067",
                  border: "1px solid #856A00",
                  borderRadius: "6px",
                  color: "#403301",
                  fontSize: "13px",
                }}
              />
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={applyPriceHike}
                disabled={hikeLoading}
                style={{
                  background: "#856A00",
                  color: "gold",
                  border: "none",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                {hikeLoading ? "Applying..." : "Apply Hike"}
              </button>
              <button
                onClick={() => setShowHikeModal(false)}
                style={{
                  background: "transparent",
                  color: "#403301",
                  border: "1px solid #856A00",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Barcode Scanner */}
      <div
        style={{
          background: "#928243",
          border: "1px solid #856A00",
          borderRadius: "10px",
          padding: "16px",
          marginBottom: "16px",
        }}
      >
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <span style={{ fontSize: "20px" }}>Barcode Details</span>
          <input
            type="text"
            placeholder="Scan barcode here or type barcode number..."
            value={scanInput}
            onChange={(e) => setScanInput(e.target.value)}
            onKeyDown={handleScan}
            style={{
              ...inputStyle,
              flex: 1,
              fontSize: "14px",
              padding: "10px 12px",
            }}
          />
        </div>
        {scanResult && (
          <div
            style={{
              marginTop: "12px",
              padding: "12px",
              background: "#C2B067",
              borderRadius: "8px",
            }}
          >
            {scanResult.notFound ? (
              <div style={{ color: "#a32d2d", fontWeight: "bold" }}>
                ❌ Barcode {scanResult.barcode} not found
              </div>
            ) : (
              <div style={{ color: "#403301" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    marginBottom: "8px",
                  }}
                >
                  ✅ Item Found!
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    flexWrap: "wrap",
                    fontSize: "13px",
                  }}
                >
                  <span>
                    Name: <strong>{scanResult.name}</strong>
                  </span>
                  <span>
                    Category: <strong>{scanResult.category}</strong>
                  </span>
                  <span>
                    Purity: <strong>{scanResult.purity || "-"}</strong>
                  </span>
                  <span>
                    Weight: <strong>{scanResult.weightGrams}g</strong>
                  </span>
                  <span>
                    Making: <strong>₹{scanResult.makingCharge}</strong>
                  </span>
                  <span>
                    Qty: <strong>{scanResult.quantity}</strong>
                  </span>
                  <span>
                    Status: <strong>{scanResult.status}</strong>
                  </span>
                  {scanResult.karigar && (
                    <span>
                      Karigar: <strong>{scanResult.karigar}</strong>
                    </span>
                  )}
                </div>
                <button
                  onClick={() => setScanResult(null)}
                  style={{
                    marginTop: "10px",
                    background: "#856A00",
                    color: "gold",
                    border: "none",
                    padding: "6px 14px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  Clear
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      {/* Add Item Form */}
      {showForm && (
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <h3 style={{ marginTop: 0, color: "#403301" }}>New Item</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "12px",
            }}
          >
            <div>
              <label style={labelStyle}>Item Name</label>
              <input
                name="name"
                type="text"
                placeholder="Gold Ring"
                value={form.name}
                onChange={handleChange}
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Category</label>
              <select
                name="category"
                value={form.category}
                onChange={(e) =>
                  setForm({ ...form, category: e.target.value, purity: "" })
                }
                style={inputStyle}
              >
                <option value="">Select</option>
                <option>Gold</option>
                <option>Silver</option>
                <option>Diamond</option>
                <option>Other</option>
              </select>
            </div>
            {(form.category === "Gold" ||
              form.category === "Silver" ||
              form.category === "Diamond") && (
              <div>
                <label style={labelStyle}>{getPurityLabel()}</label>
                <input
                  name="purity"
                  type="text"
                  placeholder={getPurityPlaceholder()}
                  value={form.purity}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
            )}
            <div>
              <label style={labelStyle}>Weight (grams)</label>
              <input
                name="weightGrams"
                type="number"
                min="0"
                placeholder="5.2"
                value={form.weightGrams}
                onChange={(e) => {
                  if (parseFloat(e.target.value) < 0) return;
                  handleChange(e);
                }}
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Making Charge</label>
              <div style={{ display: "flex", gap: "6px" }}>
                <select
                  value={makingType}
                  onChange={(e) => setMakingType(e.target.value)}
                  style={{
                    padding: "8px",
                    background: "#C2B067",
                    border: "1px solid #856A00",
                    borderRadius: "6px",
                    color: "#403301",
                    fontSize: "12px",
                  }}
                >
                  <option value="fixed">₹ Fixed</option>
                  <option value="percent">% /gram</option>
                </select>
                <input
                  name="makingCharge"
                  type="number"
                  min="0"
                  placeholder={makingType === "fixed" ? "2600" : "12"}
                  value={form.makingCharge}
                  onChange={(e) => {
                    if (parseFloat(e.target.value) < 0) return;
                    handleChange(e);
                  }}
                  style={{ ...inputStyle, flex: 1 }}
                />
              </div>
            </div>
            <div>
              <label style={labelStyle}>Quantity</label>
              <input
                name="quantity"
                type="number"
                min="0"
                placeholder="1"
                value={form.quantity}
                onChange={(e) => {
                  if (parseFloat(e.target.value) < 0) return;
                  handleChange(e);
                }}
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>HUID</label>
              <input
                name="huid"
                type="text"
                placeholder="AB1234"
                value={form.huid}
                onChange={handleChange}
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Karigar (Maker)</label>
              <input
                name="karigar"
                type="text"
                placeholder="e.g. Ramesh Kumar"
                value={form.karigar}
                onChange={handleChange}
                style={inputStyle}
              />
            </div>
          </div>
          <div style={{ marginTop: "16px", display: "flex", gap: "10px" }}>
            <button
              onClick={handleSubmit}
              style={{
                background: "#856A00",
                color: "gold",
                border: "none",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Save Item
            </button>
            <button
              onClick={() => setShowForm(false)}
              style={{
                background: "transparent",
                color: "#403301",
                border: "1px solid #856A00",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Items Table */}
      <div
        style={{
          background: "#928243",
          border: "1px solid #856A00",
          borderRadius: "10px",
          overflow: "auto",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #856A00" }}>
              {[
                "Barcode",
                "Name",
                "Category",
                "Purity/Carat",
                "Weight",
                "Making",
                "Karigar",
                "Qty",
                "Status",
                "Print",
                "Delete",
              ].map((h, i) => (
                <th
                  key={i}
                  style={{
                    padding: "12px",
                    textAlign: "left",
                    fontSize: "11px",
                    color: "#403301",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td
                  colSpan="11"
                  style={{
                    padding: "40px",
                    textAlign: "center",
                    color: "#403301",
                  }}
                >
                  No items yet — click + Add Item
                </td>
              </tr>
            ) : (
              items.map((item, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #856A00" }}>
                  <td
                    style={{
                      padding: "12px",
                      fontSize: "11px",
                      color: "#403301",
                      fontFamily: "monospace",
                      whiteSpace: "nowrap",
                    }}
                  >
                    |||{item.barcode}|||
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      fontSize: "13px",
                      color: "#403301",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.name}
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    {item.category}
                  </td>
                  <td style={{ padding: "12px" }}>
                    <span
                      style={{
                        background: "#856A00",
                        color: "gold",
                        padding: "2px 8px",
                        borderRadius: "20px",
                        fontSize: "11px",
                      }}
                    >
                      {item.purity || "-"}
                    </span>
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    {item.weightGrams}g
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    ₹{item.makingCharge}
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    {item.karigar || "-"}
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    {item.quantity}
                  </td>
                  <td style={{ padding: "12px" }}>
                    <span
                      style={{
                        background: "#403301",
                        color: "#efbf04",
                        padding: "2px 8px",
                        borderRadius: "20px",
                        fontSize: "11px",
                      }}
                    >
                      {item.status}
                    </span>
                  </td>
                  <td style={{ padding: "12px" }}>
                    <button
                      onClick={() => printBarcode(item.barcode, item.name)}
                      style={{
                        background: "#856A00",
                        color: "gold",
                        border: "none",
                        padding: "4px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "11px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Print
                    </button>
                  </td>
                  <td style={{ padding: "12px" }}>
                    <button
                      onClick={() => {
                        if (
                          window.confirm(
                            "Are you sure you want to delete this item?",
                          )
                        ) {
                          fetch(`/api/inventory/${item.id}`, {
                            method: "DELETE",
                          }).then(() =>
                            setItems(items.filter((x) => x.id !== item.id)),
                          );
                        }
                      }}
                      style={{
                        background: "#403301",
                        color: "#ef4444",
                        border: "1px solid #ef4444",
                        padding: "4px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        fontSize: "11px",
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Inventory;
